import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import menus from "../../pages/menu";
import "./header.scss";
import logo from "../../assets/images/logoh.png";
import DocumentModal from "../layouts/DocumentModal";

const Header = () => {
  const { pathname } = useLocation();

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 100);
    });
    return () => {
      setScroll({});
    };
  }, []);

  const [menuActive, setMenuActive] = useState(false);

  const handleMenuActive = () => {
    console.log("Menu toggle clicked, current state:", menuActive);
    setMenuActive(!menuActive);
  };

  useEffect(() => {
    console.log("Menu active state changed:", menuActive);
  }, [menuActive]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuActive) {
        const nav = document.getElementById("main-nav");
        const button = document.querySelector(".mobile-button");
        const overlay = document.querySelector(".mobile-menu-overlay");

        // Close if clicking on overlay
        if (overlay && overlay.contains(event.target)) {
          setMenuActive(false);
          return;
        }

        // Close if clicking outside nav and button
        if (
          nav &&
          button &&
          !nav.contains(event.target) &&
          !button.contains(event.target)
        ) {
          setMenuActive(false);
        }
      }
    };

    if (menuActive) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [menuActive]);

  const [activeIndex, setActiveIndex] = useState(null);
  const handleDropdown = (index) => {
    setActiveIndex(index);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <header
      id="header_main"
      className={`header js-header ${scroll ? "is-fixed" : ""}`}
    >
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="header__body d-flex justify-content-between">
              <div className="header__logo">
                <Link to="/">
                  <img id="site-logo" src={logo} alt="logo" />
                </Link>
              </div>

              <div className="header__right">
                {menuActive && (
                  <div
                    className="mobile-menu-overlay"
                    onClick={() => {
                      console.log("Overlay clicked");
                      setMenuActive(false);
                    }}
                  ></div>
                )}
                <nav
                  id="main-nav"
                  className={`main-nav ${menuActive ? "active" : ""}`}
                >
                  <div className="mobile-menu-header">
                    <button
                      className="mobile-menu-close"
                      onClick={() => {
                        console.log("Close button clicked");
                        setMenuActive(false);
                      }}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  </div>
                  <ul id="menu-primary-menu" className="menu">
                    {menus.map((data, index) => (
                      <li
                        key={index}
                        onClick={() => handleDropdown(index)}
                        className={`menu-item ${
                          data.namesub ? "menu-item-has-children" : ""
                        } ${activeIndex === index ? "active" : ""} ${
                          pathname === data.links ? "active" : ""
                        } `}
                      >
                        <a
                          href={data.links}
                          onClick={() => setMenuActive(false)}
                        >
                          {data.name_es}
                        </a>
                        {data.namesub && (
                          <ul className="sub-menu">
                            {data.namesub.map((submenu) => (
                              <li
                                key={submenu.id}
                                className={
                                  pathname === submenu.links
                                    ? "menu-item current-item"
                                    : "menu-item"
                                }
                              >
                                <Link
                                  to={submenu.links}
                                  onClick={() => setMenuActive(false)}
                                >
                                  {submenu.sub}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                    <li className="menu-item menu-item-document">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleOpenModal(e);
                          setMenuActive(false);
                        }}
                        className="document-menu-link"
                      >
                        <i className="fas fa-file-pdf"></i>
                        <span>Sentencias Judiciales</span>
                      </a>
                    </li>
                  </ul>
                </nav>
                <div className="download-btn-container">
                  <a
                    href="#"
                    onClick={handleOpenModal}
                    className="download-btn"
                  >
                    <i className="fas fa-file-pdf"></i>
                    <span>Sentencias Judiciales</span>
                  </a>
                </div>
                <DocumentModal
                  isOpen={isModalOpen}
                  onClose={handleCloseModal}
                />
                <ul className="social">
                  <li>
                    <Link to="#">
                      <i className="fab fa-facebook-f"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fab fa-twitter"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fab fa-linkedin-in"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fab fa-youtube"></i>
                    </Link>
                  </li>
                </ul>
                <div
                  className={`mobile-button ${menuActive ? "active" : ""}`}
                  onClick={handleMenuActive}
                >
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
